import { object, string, date, array, number, boolean } from 'yup';

export const unserializedStockingValidation = (maxQuantity: number) =>
  object().shape({
    lot: string().nullable(),
    expiration: date().nullable(),
    zoneId: string().required('Zone is required'),
    quantity: number()
      .required('Quantity is required')
      .min(1, 'Quantity must be at least 1')
      .max(maxQuantity, `Cannot exceed remaining quantity (${maxQuantity})`)
  });
